import { render, staticRenderFns } from "./TaskStatusBadge.vue?vue&type=template&id=0ebc2d05&scoped=true"
import script from "./TaskStatusBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskStatusBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TaskStatusBadge.vue?vue&type=style&index=0&id=0ebc2d05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebc2d05",
  null
  
)

export default component.exports